import { functionShowcaseData } from '@/mocks/home';

const showcaseImages: Record<string, string> = {
  'func-1': 'https://readdy.ai/api/search-image?query=Contact%20import%20interface%20showing%20multiple%20platform%20connection%20options%20with%20progress%20visualization%20on%20laptop%20screen%2C%20warm%20amber%20accents%2C%20clean%20modern%20UI%2C%20professional%20desk%20environment%20with%20natural%20light&width=800&height=600&seq=func-import-01&orientation=landscape',
  'func-2': 'https://readdy.ai/api/search-image?query=Interactive%20network%20graph%20visualization%20showing%20professional%20connections%20with%20nodes%20and%20links%20on%20large%20display%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20modern%20office%20environment%2C%20clean%20minimalist%20design%2C%20high%20detail%20editorial&width=800&height=600&seq=func-graph-02&orientation=landscape',
  'func-3': 'https://readdy.ai/api/search-image?query=Smart%20reminder%20dashboard%20showing%20upcoming%20follow-ups%20with%20priority%20indicators%20on%20tablet%20screen%2C%20warm%20amber%20accent%20design%2C%20clean%20modern%20interface%2C%20coffee%20shop%20background%20with%20soft%20natural%20light&width=800&height=600&seq=func-reminder-03&orientation=landscape',
};

export default function FunctionShowcase() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="showcase-heading">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 id="showcase-heading" className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
            让每一次联系都井井有条
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            从导入到维护，从分析到提醒——三大核心场景，全面升级您的人脉管理体验
          </p>
        </div>

        <div className="flex flex-col gap-16 md:gap-20">
          {functionShowcaseData.map((item, index) => {
            const isReversed = index % 2 === 1;
            return (
              <div
                key={item.id}
                className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 md:gap-12 items-center`}
              >
                <div className="w-full lg:w-1/2">
                  <div className="relative w-full aspect-[4/3] overflow-hidden rounded-lg bg-background-200">
                    <img
                      src={showcaseImages[item.id]}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-4">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                    {item.description}
                  </p>
                  <ul className="flex flex-col gap-3">
                    {item.points.map((point, i) => (
                      <li key={i} className="flex items-start gap-3">
                        <span className="w-5 h-5 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-xs"></i>
                        </span>
                        <span className="text-sm text-foreground-700">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}